<template>
  <div style="margin:auto;" class="d-flex justify-content-center">
    <div>
      <input style="border-style: solid" ref="d0" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[0]"
        data-index="0" class="form-control" maxlength="1" />
    </div>
    <div>
      <input style="border-style: solid" ref="d1" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[1]"
        data-index="1" class="form-control" maxlength="1" />
    </div>
    <div>
      <input style="border-style: solid" ref="d2" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[2]"
        data-index="2" class="form-control" maxlength="1" />
    </div>
    <div>
      <input style="border-style: solid" ref="d3" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[3]"
        data-index="3" class="form-control" maxlength="1" />
    </div>
    <div>
      <input style="border-style: solid" ref="d4" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[4]"
        data-index="4" class="form-control" maxlength="1" />
    </div>
    <div>
      <input style="border-style: solid" ref="d5" @input="onInput" @paste="(e) => onPaste(e)" v-model="d[5]"
        data-index="5" class="form-control" maxlength="1" />
    </div>

  </div>
</template>

<script>
export default {
  props: ["modelValue"],
  emits: ["update:modelValue"],
  data() {
    return {
      d: [],
    };
  },
  methods: {
    Verifyclear() {
      this.d = [];
      this.$emit("input", null);
    },
    onInput() {
      let len = 0;
      let rv = "";
      for (let i = 0; i < this.d.length; i++) {
        if (this.d[i]) {
          len++;
          rv += this.d[i] + "";
        }
      }
      this.setNextInput(rv, len);
    },
    onPaste(e) {
      e.preventDefault();
      let pastedData = (e.clipboardData || window.clipboardData).getData('text');

      if (pastedData.length === 0) {
        return;
      }

      const currentIndex = Number(e.target.getAttribute('data-index'));
      const remainingLengthFromCurrentIndex = 6 - currentIndex;

      if (pastedData.length > remainingLengthFromCurrentIndex) {
        pastedData = pastedData.slice(0, remainingLengthFromCurrentIndex);
      }

      let currentLength = 0;
      let rv = "";

      const lastPosition = currentIndex + pastedData.length - 1;
      for (let index = 0; index < 6; index++) {
        if (index < currentIndex || index > lastPosition) {
          if (this.d[index]) {
            rv += this.d[index] + "";
            currentLength++;
          }
          continue;
        }

        this.$set(this.d, index, pastedData[index - currentIndex]);
        rv += this.d[index] + "";
        currentLength++;
      }

      this.setNextInput(rv, currentLength)
    },
    setNextInput(value, length) {
      if (length == 1) this.$refs.d1.focus();
      if (length == 2) this.$refs.d2.focus();
      if (length == 3) this.$refs.d3.focus();
      if (length == 4) this.$refs.d4.focus();
      if (length == 5) this.$refs.d5.focus();

      if (length == 6) {
        this.$emit("input", value);
      } else {
        this.$emit("input", null);
      }
    }
  },
};
</script>

<style scoped>
.form-control {
  max-width: 45px;
  margin-right: 5px;
  text-align: center;
  font-size: 25px;
}
</style>
